module.exports = __webpack_public_path__ + "static/img/more-text-3.b40e3437.png";